import { KlaviyoBackInStock } from "@theme/klaviyo-back-in-stock";
import { ViewedProduct } from "@theme/viewed-product";
import { Recommendations } from "@theme/recommendations";
import { GWPCarouselController } from "@theme/gwp-carousel";
import "@theme/lightbox";

new KlaviyoBackInStock();
new ViewedProduct();
new Recommendations();

// Initialize GWP Carousel Controller
const gwpController = new GWPCarouselController();
gwpController.init();
